import type { IConversationModel } from '@tencentcloud/chat-uikit-engine';
import type { PaginationRes } from '@zsdx/material-antd';
import { request } from '@/utils/request';

/**
 * 获取可转接的客服列表
 */
export const getSwitchCustomerServiceList = () => {
    return request.post<{ list: SESSION_API.CustomerServiceInfo[] }>(
        '/student-app/customer/system/getSwitchKfList'
    );
};

/**
 * 转接客服
 */
export const exchangeCustomerService = (data: {
    kfGroupId?: string;
    type: number;
    groupId: string;
    customerImId?: string;
    consultProblemType?: string;
    exchangeInShopId?: string;
}) => {
    return request.post('/student-app/session/exchange', data);
};

export const querySessionRecord = (params: SESSION_API.SessionParams) => {
    return request.post<any>('/student-app/session/query', params);
};

export const getCustomerList = (params: SESSION_API.CustomerParams) => {
    return request.post<any>('/student-app/customer/system/getCustomerList', params);
};

export const getEndSession = async () => {
    const data = await request.post<SESSION_API.ConversationItem[]>(
        '/student-app/session/getEndSession'
    );

    return data.map(conversation => {
        const res = {
            getAvatar: () => conversation.headImg,
            getShowName: () => conversation.nickName,
            isMuted: false,
            lastMessage: {
                getLastMessage: (field: string) =>
                    field === 'time' ? conversation.sessionTime : undefined,
                messageForShow: ''
            },
            unreadCount: 0,
            isPinned: false,
            groupProfile: {
                groupID: conversation.groupId
            },
            competitionType: conversation.competitionType
        };

        return res as any as IConversationModel;
    });
};

export const reopenSession = (params: { groupId: string }) => {
    return request.post<void>('/student-app/session/reOpen', params);
};

export const getUserInfo = (params: { userId: string }) => {
    return request.post<SESSION_API.UserInfo>('/student-app/customer/system/getUserInfo', params);
};
export const getCompanyInfo = (params: { userId?: string; userImId?: string }) => {
    return request.post<SESSION_API.MerchantsInfo>(
        '/student-app/customer/system/getCompanyUserInfo',
        params
    );
};

export const getCompanyShopInfo = (params: { userId?: string; userImId?: string }) => {
    return request.post<SESSION_API.CompanyShopInfo>(
        '/student-app//customer/system/getCompanyShopInfo',
        params
    );
};

export const listConsultProblemType = () => {
    return request.post<SESSION_API.ConsultProblemType[]>(
        '/student-app/customer/system/listConsultProblemType'
    );
};

export const listEnableKfShop = (params: { keyword?: string }) => {
    return request.post<SESSION_API.EnableKfShopOption[]>(
        '/student-app/customer/system/listEnableKfShop',
        params
    );
};

export const listShopKf = (params: { keyword?: string }) => {
    return request.post<SESSION_API.ShopKfOption[]>(
        '/student-app/customer/system/listShopKf',
        params
    );
};

export const getSessionBaseInfo = (params: { groupId: string }) => {
    return request.post<SESSION_API.SessionBaseInfo>(
        '/student-app/session/getSessionBaseInfo',
        params
    );
};

export const saveConsultProblemTypeInfo = (params: SESSION_API.SaveConsultProblemTypeInfoReq) => {
    return request.post<void>('/student-app/session/saveConsultProblemTypeInfo', params);
};

export const getOrderList = (params: SESSION_API.OrderListRes) => {
    return request.post<PaginationRes<SESSION_API.OrderItem>>(
        '/student-app/customer/orderGoods/OrderList',
        params
    );
};

export const recordOpenSession = (params: { sessionId: string }) => {
    return request.post<string>('/student-app/session/record/openSession', params);
};

export const userOpenSession = (params: { groupId: string; userImId: string }) => {
    return request.post<string>('/student-app/session/user/openSession', params);
};

/**
 * 记录最后回复时间
 */
export const recordLastReplyTime = (groupId: string, type: number, scene?: number) => {
    return request.post('/student-app/session/recordReplyTime', {
        groupId,
        lastReplyTime: new Date().getTime(),
        type,
        scene
    });
};

export const getGroupUserInfo = (params: { groupId: string }) => {
    return request.post<SESSION_API.UserInfo>('/student-app/session/getUserInfo', params);
};

// 完结会话
export const closeSession = (params: SESSION_API.CloseSessionReq) => {
    return request.post<boolean>('/student-app/session/closeSession', params);
};

/*-------- 订单相关  ----------*/
export const getAfterOrderList = (params: SESSION_API.OrderReturnReq) => {
    return request.post<PaginationRes<SESSION_API.OrderReturnResp>>(
        '/student-app/customer/orderGoods/OrderReturnList',
        params
    );
};

export const getOrderGoodsList = (params: SESSION_API.OrderGoodsReq) => {
    return request.post<SESSION_API.OrderGoodsResp>(
        '/student-app/customer/orderGoods/goodsInfo',
        params
    );
};

export const checkCustomerCreateOrderReturn = (params: { orderId: string; userId: string }) => {
    return request.post<SESSION_API.CommonValidateRes>(
        '/student-app/order/return/checkCustomerCreateOrderReturn',
        params
    );
};

// 查询订单售后原因枚举。code：编码，desc：显示的描述-刘国涵
export const getOrderReturnApplyReasonList = (params: SESSION_API.OrderReturnApplyReasonReq) => {
    return request.post<SESSION_API.OrderReturnApplyReasonItem[]>(
        '/student-app/order/return/orderReturnApplyReason',
        params
    );
};

/**
 * 客服发起售后预览信息-张思平 （查可售后商品）
 */
export function getOrderGoodsPreview(params: { orderId: string }) {
    return request.post<SESSION_API.OrderGoodsPreview>(
        '/student-app/order/return/customerOrderReturnPreview',
        params
    );
}

// 售后申请信息预览-刘国涵
export function getOrderReturnPreview(params: SESSION_API.OrderReturnPreviewReq) {
    return request.post<SESSION_API.OrderReturnPreviewRes>(
        '/student-app/order/return/createPreview',
        params
    );
}

// 创建地址
export function createAddressApi(params: unknown) {
    return request.post<string>('/student-app/student/address/create', params);
}

// 金额实时计算展示-刘国涵
export function getMaxReturnMoneyApi(params: SESSION_API.MaxReturnMoneyReq) {
    return request.post<{ money?: number }>('/student-app/order/return/moneyShow', params);
}

// 售后申请-刘国涵
export function orderReturnCreate(params: unknown) {
    return request.post('/student-app/order/return/create', params);
}

/** ImSessionController - 查询会话结束倒计时-张玉龙 */
export function querySessionCountdownToEnd(params: SESSION_API.QuerySessionCountdownToEndReq) {
    return request.post<SESSION_API.QuerySessionCountdownToEndRes[]>(
        '/student-app/session/querySessionCountdownToEnd',
        params
    );
}

/** /student-app/customer/evaluation/listReason - 不满意原因列表-张玉龙 */
export function listReason() {
    return request.post<SESSION_API.ListReasonRes[]>('/student-app/customer/evaluation/listReason');
}

/** /student-app/customer/evaluation/saveEvaluationContent - 保存/更新评价 */
export function saveEvaluationContent(params: SESSION_API.SaveEvaluationContentReq) {
    return request.post('/student-app/customer/evaluation/saveEvaluationContent', params);
}

/** /student-app/customer/evaluation/getEvaluationContent - 保存/更新评价 */
export function getEvaluationContent(params: SESSION_API.GetEvaluationContentReq) {
    return request.post<SESSION_API.GetEvaluationContentRes>(
        '/student-app/customer/evaluation/getEvaluationContent',
        params
    );
}

/** /student-app/tag/route/userChannelPageList - 用户渠道标签路由分页列表 */
export function getUserChannelTagRoutePageList(params: SESSION_API.TagRouteUserChannelPageListReq) {
    return request.post<SESSION_API.TagRouteUserChannelPageListRes>(
        '/student-app/tag/route/userChannelPageList',
        params
    );
}

/** /student-app/tag/operateLog/pageList - 标签统一审计日志分页列表 */
export function getTagOperateLogPageList(params: SESSION_API.TagOperateLogPageListReq) {
    return request.post<SESSION_API.TagOperateLogPageListRes>(
        '/student-app/tag/operateLog/pageList',
        params
    );
}

/** /student-app/tag/data/list - 查询标签数据 */
export function getTagDataList(params: SESSION_API.TagDataListReq) {
    return request.post<SESSION_API.TagDataItem[]>('/student-app/tag/data/list', params);
}

/** /student-app/tag/data/create - 新增标签数据 */
export function createTagData(params: SESSION_API.TagDataCreateReq) {
    return request.post<void>('/student-app/tag/data/create', params);
}

/** /student-app/v2/tag/enum/pageList - 枚举值分页列表 */
export function getTagEnumPageList(params: SESSION_API.TagEnumPageListReq) {
    return request.post<SESSION_API.TagEnumPageListRes>(
        '/student-app/v2/tag/enum/pageList',
        params
    );
}

/** /student-app/tag/data/remove - 移除标签数据 */
export function removeTagData(params: SESSION_API.TagDataRemoveReq) {
    return request.post<void>('/student-app/tag/data/remove', params);
}
